import React from 'react'

import styled from 'styled-components'
import ButtonComponent from '../components/ButtonComponent'
import ContentArea from '../components/ContentArea'

const HomePage = () => {
  const HomeHeader = styled.h1`
    font-weight: 500;
    margin-bottom: 2.5rem !important;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `

  return (
    <ContentArea home transparent shadowless fullsize>
      <HomeHeader>Welcome</HomeHeader>
      <ButtonComponent text="Stress Relief" link="/stressrelief" />
      <ButtonComponent text="Sleep" link="/sleep" />
      <ButtonComponent text="Music as Medicine" link="/music" />
      <ButtonComponent text="Nutrition" link="/nutrition" last />
    </ContentArea >
  )
}


export default HomePage
